export default __webpack_public_path__ + "static/media/ipcheckout.28cdf96d.svg";